import { FunctionComponent } from 'react';
import { Outlet } from 'react-router-dom';
import { ClientLpListSubscriber } from '@cbridge-packages/lp-client';
import { SymbolGroupsSubscriber } from '@cbridge-packages/symbol-groups';

export const SymbolsLpDataLayout: FunctionComponent = () => (
  <>
    <ClientLpListSubscriber />
    <SymbolGroupsSubscriber />
    <Outlet />
  </>
);
